import { render, staticRenderFns } from "./BrandDetails.vue?vue&type=template&id=b22911fc&scoped=true"
import script from "./BrandDetails.vue?vue&type=script&lang=ts"
export * from "./BrandDetails.vue?vue&type=script&lang=ts"
import style0 from "./BrandDetails.vue?vue&type=style&index=0&id=b22911fc&lang=scss"
import style1 from "./BrandDetails.vue?vue&type=style&index=1&id=b22911fc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22911fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b22911fc')) {
      api.createRecord('b22911fc', component.options)
    } else {
      api.reload('b22911fc', component.options)
    }
    module.hot.accept("./BrandDetails.vue?vue&type=template&id=b22911fc&scoped=true", function () {
      api.rerender('b22911fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/brand/components/BrandDetails.vue"
export default component.exports